<template>
  <div>
    <BaseText inline>
      {{ $t('admin.invoices.content.logo_description') }}
    </BaseText>
    <BaseText :routerLink="{ name: 'admin-company' }">
      {{ $t('admin.invoices.content.logo_description_link') }}
    </BaseText>
  </div>
</template>
